<template lang="pug">
  page
    section.pageheader
      .container#info-container
        h1 Terms of Use

      .container
        .row
          .col-sm-12
            p Startup Cross Sell (https://business.startupmission.in) is an online portal that has been created to provide opportunities available for Startups from Industry, Corporates and Industry bodies getting associated with Kerala Startup Mission (KSUM). The documents and information displayed in this website are for reference purposes only and do not purport to be a legal document.
            p Neither the Department of Electronics & Information Technology, Government of Kerala, nor KSUM does warrant the accuracy or completeness of the information, text, graphics, links or other items contained within the Startup Cross Sell online portal. As a result of updates and corrections, the web contents are subject to change regularly.
            p The information posted on this website could include hypertext links or pointers to information created and maintained by non-Government/private organisations. KSUM is providing these links and pointers solely for your information and convenience. When you select a link to an outside website, you are leaving the 'Guidelines for Indian Government Websites' site and are subject to the privacy and security policies of the owners/sponsors of the outside website.
            p These terms and conditions shall be governed by and construed in accordance with the Indian Laws. Any dispute arising under these terms and conditions shall be subject to the jurisdiction of the courts of Kerala.



</template>

<script>
// @ is an alias to /src
import page from '@/components/frontend/page'
export default {
  name: 'Home',
  components: {
    page
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/_mixins';
#info-container{
  padding-top: 150px;
 h1{
    font-weight: 400;
    font-size: 1.8rem;
  }
}
.pageheader{
  @include my_bp(sm){
    padding-bottom: 350px;
  }
}
p{
  text-align: justify;
}
</style>